import { render, staticRenderFns } from "./ArticleInfoModal.vue?vue&type=template&id=5ac80e94&"
import script from "./ArticleInfoModal.vue?vue&type=script&lang=js&"
export * from "./ArticleInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ArticleInfoModal.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports